import { Directive, ElementRef, EventEmitter, HostListener, Input, NgZone, Output, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[unhClickedOut]'
})

export class ClickedOutDirective {
  element;
  private wasInside = false;

  trullyEnabled: boolean
  @Input() set enable(value) {
    if (value) {
      setTimeout(() => this.trullyEnabled = true, 10)
    }
  }

  @Output() clickedout = new EventEmitter();

  @HostListener('click')
  clickInside() {
    if (this.trullyEnabled) {
      this.wasInside = true;
      this.clickedout.emit(true);
    }
  }

  @HostListener('document:click', ['$event.target'])
  clickout(target) {
    if (this.trullyEnabled && !this.element.contains(target)) {
      this.clickedout.emit(false);
    }
    this.wasInside = false;

  }

  constructor(
    private _el: ElementRef,
  ) {
    this.element = this._el.nativeElement;
  }
}

export function debounce(delay: number = 10): MethodDecorator {
  return (target, propertyKey, descriptor) => {
    const timeoutKey = Symbol();

    const original: any = descriptor.value;

    (descriptor as any).value = function (...args) {
      clearTimeout(this[timeoutKey]);
      this[timeoutKey] = setTimeout(() => original.apply(this, args), delay);
    };

    return descriptor;
  };
}
